import createIcon from "components/elements/Icons/create-icon";

export default createIcon("ChartLineLight", [
  [
    "path",
    {
      d: "M21.5739 6.57386L21.5739 6.57385C21.6692 6.47851 21.8308 6.47851 21.9261 6.57385C22.0215 6.66921 22.0215 6.83076 21.9261 6.92614C21.9261 6.92614 21.9261 6.92615 21.9261 6.92615L15.1761 13.6761C15.0808 13.7715 14.9192 13.7715 14.8239 13.6761L10.8536 9.70585L10.5 9.35229L10.1464 9.70585L5.42615 14.4261C5.33078 14.5215 5.16922 14.5215 5.07385 14.4261C4.97851 14.3308 4.97851 14.1692 5.07385 14.0739L5.07386 14.0739L10.3239 8.82386L10.3239 8.82385C10.4192 8.72852 10.5808 8.72851 10.6761 8.82385L10.6761 8.82386L14.6464 12.7942L15 13.1477L15.3536 12.7942L21.5739 6.57386ZM0.75 2C0.886358 2 1 2.11364 1 2.25V18.75C1 20.2683 2.23167 21.5 3.75 21.5H23.25C23.3864 21.5 23.5 21.6136 23.5 21.75C23.5 21.8864 23.3864 22 23.25 22H3.75C1.95426 22 0.5 20.5458 0.5 18.75V2.25C0.5 2.11364 0.613642 2 0.75 2Z",
    },
  ],
]);
